import { render, staticRenderFns } from "./specialColumn.vue?vue&type=template&id=48624316&scoped=true&"
import script from "./specialColumn.vue?vue&type=script&lang=js&"
export * from "./specialColumn.vue?vue&type=script&lang=js&"
import style0 from "./specialColumn.vue?vue&type=style&index=0&id=48624316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48624316",
  null
  
)

export default component.exports